import { createSlice } from '@reduxjs/toolkit'
import { PuzzleState } from './types'
import { postPuzzleGuess } from './puzzleThunk'

const initialState: PuzzleState = {
  data: null,
  loading: false,
  error: null,
}

const puzzleSlice = createSlice({
  name: 'puzzle',
  initialState,
  reducers: {
    clearPuzzle: (state) => {
      state.data = null
      state.error = null
      state.loading = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postPuzzleGuess.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(postPuzzleGuess.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(postPuzzleGuess.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
        state.data = null
      })
  },
})

export const { clearPuzzle } = puzzleSlice.actions

export default puzzleSlice.reducer
